<template>
  <v-card>
    <div style="min-height: 4px">
      <v-progress-linear
        v-if="loading"
        indeterminate
      ></v-progress-linear>
    </div>
    <v-card-title class="align-start mb-8">
      <span>Atendimento por Canal</span>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col
          v-for="data in dadosTickets"
          :key="data.nomeCanal"
          cols="6"
          md="3"
          class="d-flex align-center"
        >
          <v-avatar
            size="44"
            rounded
            class="elevation-1"
            :color="resolveStatisticsIconVariation(data.tipoCanal).color"
          >
            <v-icon
              dark
              color="white"
              size="30"
            >
              {{ resolveStatisticsIconVariation(data.tipoCanal).icon }}
            </v-icon>
          </v-avatar>
          <div class="ms-3">
            <p class="text-xs mb-0">
              {{ data.nomeCanal }}
            </p>
            <h3 class="text-xl font-weight-semibold">
              {{ data.totalTicketsCanal }}
            </h3>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  mdiAccountCheck, mdiTrendingUp, mdiDotsVertical, mdiEmail, mdiWhatsapp, mdiFileDocument,
} from '@mdi/js'

export default {
  props: {
    dadosTickets: {
      type: Array,
      required: true,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },

  },

  data: () => ({
  }),

  methods: {
  },

  setup() {
    const resolveStatisticsIconVariation = data => {
      if (data === 'E-mail') return { icon: mdiEmail, color: 'primary' }
      if (data === 'WhatsApp') return { icon: mdiWhatsapp, color: 'primary' }
      if (data === 'Autoatendimento') return { icon: mdiAccountCheck, color: 'primary' }
      if (data === 'Abertura Manual') return { icon: mdiFileDocument, color: 'primary' }

      return { icon: mdiTrendingUp, color: 'success' }
    }

    return {
      resolveStatisticsIconVariation,
      icons: {
        mdiDotsVertical,
      },
    }
  },
}
</script>
